export const getTableConfig = (year) => [
  {
    name: "serviceName",
    label: "Kategori Job",
    options: { sort: false }
  },

  { name: "jan", label: "JAN", options: { sort: false } },
  { name: "janPercentage", label: "% dr Total Per Bulan", options: { sort: false } },

  { name: "feb", label: "FEB", options: { sort: false } },
  { name: "febPercentage", label: "% dr Total Per Bulan", options: { sort: false } },

  { name: "mar", label: "MAR", options: { sort: false } },
  { name: "marPercentage", label: "% dr Total Per Bulan", options: { sort: false } },

  { name: "apr", label: "APR", options: { sort: false } },
  { name: "aprPercentage", label: "% dr Total Per Bulan", options: { sort: false } },

  { name: "may", label: "MEI", options: { sort: false } },
  { name: "mayPercentage", label: "% dr Total Per Bulan", options: { sort: false } },

  { name: "jun", label: "JUN", options: { sort: false } },
  { name: "junPercentage", label: "% dr Total Per Bulan", options: { sort: false } },

  { name: "jul", label: "JUL", options: { sort: false } },
  { name: "julPercentage", label: "% dr Total Per Bulan", options: { sort: false } },

  { name: "aug", label: "AGU", options: { sort: false } },
  { name: "augPercentage", label: "% dr Total Per Bulan", options: { sort: false } },

  { name: "sep", label: "SEP", options: { sort: false } },
  { name: "sepPercentage", label: "% dr Total Per Bulan", options: { sort: false } },

  { name: "oct", label: "OKT", options: { sort: false } },
  { name: "octPercentage", label: "% dr Total Per Bulan", options: { sort: false } },

  { name: "nov", label: "NOV", options: { sort: false } },
  { name: "novPercentage", label: "% dr Total Per Bulan", options: { sort: false } },

  { name: "dec", label: "DES", options: { sort: false } },
  { name: "decPercentage", label: "% dr Total Per Bulan", options: { sort: false } },

  {
    name: "total",
    label: `YEAR TO DATE (${year})`,
    options: { sort: false }
  },
  {
    name: "totalPercentage",
    label: "% dr Total Per Bulan",
    options: { sort: false }
  }
];

export const mapJobYTDToTable = (data) => {
  if (!data) return [];

  const rows = data.services.map((item) => ({
    serviceName: item.serviceName,

    jan: item.jan,
    janPercentage: `${item.janPercentage}%`,

    feb: item.feb,
    febPercentage: `${item.febPercentage}%`,

    mar: item.mar,
    marPercentage: `${item.marPercentage}%`,

    apr: item.apr,
    aprPercentage: `${item.aprPercentage}%`,

    may: item.may,
    mayPercentage: `${item.mayPercentage}%`,

    jun: item.jun,
    junPercentage: `${item.junPercentage}%`,

    jul: item.jul,
    julPercentage: `${item.julPercentage}%`,

    aug: item.aug,
    augPercentage: `${item.augPercentage}%`,

    sep: item.sep,
    sepPercentage: `${item.sepPercentage}%`,

    oct: item.oct,
    octPercentage: `${item.octPercentage}%`,

    nov: item.nov,
    novPercentage: `${item.novPercentage}%`,

    dec: item.dec,
    decPercentage: `${item.decPercentage}%`,

    total: item.total,
    totalPercentage: `${item.totalPercentage}%`,
  }));

  if (data.total) {
    rows.push({
      serviceName: "TOTAL",
      ...data.total,
      janPercentage: `${data.total.janPercentage}%`,
      febPercentage: `${data.total.febPercentage}%`,
      marPercentage: `${data.total.marPercentage}%`,
      aprPercentage: `${data.total.aprPercentage}%`,
      mayPercentage: `${data.total.mayPercentage}%`,
      junPercentage: `${data.total.junPercentage}%`,
      julPercentage: `${data.total.julPercentage}%`,
      augPercentage: `${data.total.augPercentage}%`,
      sepPercentage: `${data.total.sepPercentage}%`,
      octPercentage: `${data.total.octPercentage}%`,
      novPercentage: `${data.total.novPercentage}%`,
      decPercentage: `${data.total.decPercentage}%`,
      totalPercentage: `${data.total.totalPercentage}%`,
    });
  }

  return rows;
};

const MONTHS = [
  { key: "jan", label: "JAN" },
  { key: "feb", label: "FEB" },
  { key: "mar", label: "MAR" },
  { key: "apr", label: "APR" },
  { key: "may", label: "MAY" },
  { key: "jun", label: "JUN" },
  { key: "jul", label: "JUL" },
  { key: "aug", label: "AUG" },
  { key: "sep", label: "SEP" },
  { key: "oct", label: "OCT" },
  { key: "nov", label: "NOV" },
  { key: "dec", label: "DES" },
];

export const buildExcelRequestBodyJobYTD = ({
  year,
  dataTable = [],
}) => {
  const filename = `Laporan_Jual_Year_To_Date_${year}`;
  const headers = [
    "No",
    "Kategori Job",
  ];

  MONTHS.forEach((month) => {
    headers.push(month.label);
    headers.push("% dari Total Per Bulan");
  });

  const data = dataTable.map((item, index) => {
    const row = {
      No: index + 1,
      "Kategori Job": item.serviceName,
    };

    MONTHS.forEach((month) => {
      row[month.label] = item[month.key] ?? 0;
      row["% dari Total Per Bulan"] =
        item[`${month.key}Percentage`] ?? "0%";
    });

    return row;
  });

  return {
    filename,
    sheets: [
      {
        name: "Laporan_Jual_Year_To_Date",
        headers,
        data,
      },
    ],
  };
};

